import { TablePageLayout, DataTableExRef } from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import { Button, Stack } from '@mui/material';
import React, { useRef } from 'react';

import { ClientsTable } from 'components/ClientsTable';
import { OfflineClientsPageDownloadButton } from 'components/OfflineClientsPageDownloadButton';
import { HideStationSelector } from 'layouts/HideStationSelector';

export function Clients() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <HideStationSelector>
      <TablePageLayout
        title="Klanten"
        actionContent={
          <Stack direction="row" spacing={2} sx={{ ml: 5 }}>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => {
                tableRef.current?.openFormDialog();
              }}
            >
              Klant toevoegen
            </Button>
            <OfflineClientsPageDownloadButton />
          </Stack>
        }
      >
        <ClientsTable
          id="clients-table"
          ref={tableRef}
          searchFilter={{
            inputProps: {
              placeholder: 'Zoeken op ID, naam of op andere velden van klant',
            },
            filter: (search) => ({
              _or: search.flatMap((str) => [
                ...(parseInt(str, 10)
                  ? [{ id: { _eq: parseInt(str, 10) } }]
                  : []),
                { firstName: { _ilike: `%${str}%` } },
                { lastName: { _ilike: `%${str}%` } },
                { address: { _ilike: `%${str}%` } },
                { gsm: { _ilike: `%${str}%` } },
                { phone: { _ilike: `%${str}%` } },
                { email: { _ilike: `%${str}%` } },
                { company: { name: { _ilike: `%${str}%` } } },
                { company: { bkh: { _ilike: `%${str}%` } } },
              ]),
            }),
          }}
        />
      </TablePageLayout>
    </HideStationSelector>
  );
}
